import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoaderDelegate, delegateActions } from '../components/list_loader';
import * as seasonsApi from '../api/seasons';
import { canCreateSeason, canDeleteSeason, canViewChangelog, reactListTablesEnabled } from '../permissions';
import { addChangelogListAction, addChangelogAction } from './changelog';
import { Action } from '../components/basic_widgets';
import { ListHeaderAction } from '../components/list_header';
import i18n from '../i18n';
import { translate } from '../i18n_text';
import { session } from '../session';
import { GridView } from '../utils/grid_view';
import { SeasonsListPage, SeasonsListProps, SeasonsListQuery, SeasonsListRow } from 'react-islands';

let template = require('raw-loader!../../templates/seasons.html').default;

class SeasonsScreen implements ListLoaderDelegate<seasonsApi.SeasonData, seasonsApi.SeasonData> {
  canCreate = canCreateSeason();
  // Same rule as the legacy user-log columns.
  showUserLog = canViewChangelog(null);

  listActions = ko.observableArray<ListHeaderAction>([]);

  newSeasonsTable = reactListTablesEnabled();

  private view = new GridView('seasons');

  tableProps = ko.pureComputed<SeasonsListProps>(() => ({
    view: this.view,
    fetchPage: this.fetchPage,
    showUserLog: this.showUserLog,
  }));

  constructor(params: { filters: unknown }) {
    if (this.canCreate) {
      this.listActions.push({
        title: i18n.t('Add')(),
        icon: 'add_circle',
        href: '/seasons/new/',
        tooltipTitle: i18n.t('Add Season')(),
      });
    }
    this.listActions.push(...addChangelogListAction('season'));

    if (this.newSeasonsTable) {
      this.view.load(params.filters);
    }
  }

  fetch(params: ListRequestParams) {
    return seasonsApi.list({ country_id: undefined, ...params });
  }

  private fetchPage = (query: SeasonsListQuery): Promise<SeasonsListPage> =>
    this.view.fetchListPage(query, seasonsApi.list, 'name_prefix', this);

  toRow = (season: seasonsApi.SeasonData): SeasonsListRow => ({
    id: season.id,
    name: translate(season.name_json),
    url: session.toTenantPath(this.getEditUrl(season)),
    code: season.code || '',
    countriesSummary: season.countries_summary || '',
    createdByName: season.created_by_user_name || '',
    modifiedByName: season.modified_by_user_name || '',
    actions: delegateActions(this, season, this.view.reload),
  });

  instantiate(data: seasonsApi.SeasonData) {
    return data;
  }

  getEditUrl(data: seasonsApi.SeasonData) {
    return '/seasons/' + data.id + '/';
  }

  remove(id: string) {
    return seasonsApi.remove(id);
  }

  canRemove(entity: seasonsApi.SeasonData) {
    return canDeleteSeason();
  }

  getActions(entity: seasonsApi.SeasonData): Action[] {
    return addChangelogAction('season', entity.id);
  }
}

export let seasons = {
  name: 'seasons',
  viewModel: SeasonsScreen,
  template: template,
};

ko.components.register(seasons.name, seasons);
